import { render, staticRenderFns } from "./CajaAhorroNextSteps.vue?vue&type=template&id=81bb9c36&scoped=true"
import script from "./CajaAhorroNextSteps.vue?vue&type=script&lang=js"
export * from "./CajaAhorroNextSteps.vue?vue&type=script&lang=js"
import style0 from "./CajaAhorroNextSteps.vue?vue&type=style&index=0&id=81bb9c36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81bb9c36",
  null
  
)

export default component.exports